class PerfilController extends AbstractCrudController

  configure: (configs) ->
    configs.model = 'perfil'
    configs.module = 'eficiencia-fiscal'
    configs.folder = 'configuracao/icms/perfil'
    configs.service = 'perfilIcmsService'

    configs.itemName = (perfil) -> "o perfil ##{perfil.id} - #{perfil.nome}"

  initialize: ->
    @inject('regimeTributarioIcmsService')

    @setModal('modalVinculacaoPerfil', 'vinculacao-perfil', 'vinculacaoPerfilModalController', size: 'lg', backdrop: 'static', keyboard: false)
    @setModal('modalInclusaoPerfil', 'inclusao-perfil', 'inclusaoPerfilModalController', size: 'lg', backdrop: 'static', keyboard: false)

    @listOfRegimeTributario = []
    @loadingTracker.addPromise @regimeTributarioIcmsService.getList({}, (data)=>
      @listOfRegimeTributario = data.data.items
    )

  vinculacoesPerfil: (perfil) ->
    @modalVinculacaoPerfil({
      perfil: => perfil
    })

  inclusoesPerfil: (perfil) ->
    @modalInclusaoPerfil({
      perfil: => perfil
    })

  modalResolve: (perfil) ->
    {
      perfil: => angular.copy(perfil) or {regimeTributario: @filtro.regimeTributario}
      listOfRegimeTributario: => @listOfRegimeTributario
    }

angular.module('eficienciaFiscalModule').controller('perfilController', PerfilController)

class PerfilModalController extends AbstractController
  @$inject = [ '$injector', '$uibModalInstance', 'perfilIcmsService', 'perfil', 'listOfRegimeTributario' ]

  constructor: ($injector, @modalInstance, @perfilService, @perfil, @listOfRegimeTributario) ->
    super($injector)

    @submitTracker = @promiseTracker()

  salvar: (form) ->
    if form.$valid
      @submitTracker.addPromise @perfilService.save(@perfil, (data) =>
        Alert.success("Perfil Nº  <strong>#{data.id}</strong> #{if @perfil.id then 'atualizado' else 'criado'} com sucesso.", 'Sucesso!')
        @modalInstance.close(new Retorno(true, null, data))
      )

angular.module('eficienciaFiscalModule').controller('perfilModalController', PerfilModalController)

class VinculacaoPerfilModalController extends AbstractController
  @$inject = [ '$injector', '$uibModalInstance', 'vinculacaoPerfilIcmsService', 'perfil' ]

  constructor: ($injector, @modalInstance, @vinculacaoPerfilService, @perfil) ->
    super($injector)

    @submitTracker = @promiseTracker()
    @loadingTracker = @promiseTracker()

    @loadData()

  loadData: ->
    @loadingTracker.addPromise @vinculacaoPerfilService.getList({perfil: @perfil.id}, (result) =>
      @listOfVinculacaoPerfil = result.data.items)

  remover: (vinculacaoPerfil, $event) ->
    @vinculacaoPerfilService.delete(vinculacaoPerfil.id, (result) =>
      if(result.success)
        Alert.success("O vínculo legal ##{vinculacaoPerfil.id} do perfil #{@perfil.nome} foi removido!", 'Sucesso')
        @loadData()
      else
        Alert.error("Ocorreu um erro ao remover o vinculo legal ##{vinculacaoPerfil.id}.")
    , clickEvent: $event)

  salvar: (form) ->
    if form.$valid
      @vinculacaoPerfil.perfil = @perfil.id

      @submitTracker.addPromise @vinculacaoPerfilService.save(@vinculacaoPerfil, (result) =>
        if !result.error
          Alert.success("O vínculo legal ##{result.id} do perfil #{@perfil.nome} foi #{if @vinculacaoPerfil.id then 'atualizado' else 'adicionado'} com sucesso!", 'Sucesso')
          form.$setPristine()
          @vinculacaoPerfil = null
          @loadData()
        else
          Alert.warning("Ocorreu um problema ao adicionar um vínculo legal para o perfil #{@perfil.nome}.")
      )

  editar: (vinculacaoPerfil) ->
    @vinculacaoPerfil = angular.copy vinculacaoPerfil

  addObservacao: ->
    @vinculacaoPerfil.observacoes ?= []
    @vinculacaoPerfil.observacoes.push {texto: @observacao}
    @observacao = ''

  removerObservacao: (index)->
    if(index > -1)
      @vinculacaoPerfil.observacoes.splice(index, 1)

angular.module('eficienciaFiscalModule').controller('vinculacaoPerfilModalController', VinculacaoPerfilModalController)

class InclusaoPerfilModalController extends AbstractController
  @$inject = [ '$injector', '$uibModalInstance', 'inclusaoPerfilIcmsService', 'perfil' ]

  constructor: ($injector, @modalInstance, @inclusaoPerfilService, @perfil) ->
    super($injector)

    @submitTracker = @promiseTracker()
    @loadingTracker = @promiseTracker()

    @listOfTipo = [
      {id: 'da', nome: 'Diferencial de alíquota'},
      {id: 'at', nome: 'Antecipado'}
    ]

    @loadData()

  loadData: ->
    @loadingTracker.addPromise @inclusaoPerfilService.getList({perfil: @perfil.id}, (result) =>
      @listOfInclusaoPerfil = result.data.items)

  remover: (inclusaoPerfil, $event) ->
    @inclusaoPerfilService.delete(inclusaoPerfil.id, (result) =>
      if(result.success)
        Alert.success("A inclusão de NCM/CFOP ##{inclusaoPerfil.id} do perfil #{@perfil.nome} foi removida!", 'Sucesso')
        @loadData()
      else
        Alert.error("Ocorreu um erro ao remover a inclusão de NCM/CFOP ##{inclusaoPerfil.id}.")
    , clickEvent: $event)

  salvar: (form) ->
    if form.$valid
      @inclusaoPerfil.perfil = @perfil.id

      @submitTracker.addPromise @inclusaoPerfilService.save(@inclusaoPerfil, (result) =>
        if !result.error
          Alert.success("A inclusão de NCM/CFOP ##{result.id} para perfil #{@perfil.nome} foi #{if @inclusaoPerfil.id then 'atualizada' else 'adicionada'} com sucesso!", 'Sucesso')
          form.$setPristine()
          @inclusaoPerfil = null
          @loadData()
        else
          Alert.warning("Ocorreu um problema ao adicionar uma inclusão de NCM/CFOP para o perfil #{@perfil.nome}.")
      )

  editar: (inclusaoPerfil) ->
    @inclusaoPerfil = angular.copy inclusaoPerfil

  addObservacao: ->
    @inclusaoPerfil.observacoes ?= []
    @inclusaoPerfil.observacoes.push {texto: @observacao}
    @observacao = ''

  removerObservacao: (index)->
    if(index > -1)
      @inclusaoPerfil.observacoes.splice(index, 1)

angular.module('eficienciaFiscalModule').controller('inclusaoPerfilModalController', InclusaoPerfilModalController)